angular.module('Itao.IndicatorMap').controller('CustomModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply data to scope so you can use the input date in your modal template
  $scope.data = data;

  /**
   * Closes the dialog as a dismiss result
   */
  $scope.close = function () {
    $uibModalInstance.dismiss();
  };

  /**
   * Closes the dialog as a close (success) result
   */
  $scope.accept = function () {
    $uibModalInstance.close();
  };

}]);
